// extracted by mini-css-extract-plugin
export default {"title":"InvestigateDetailHeader-module__title__Zjm1z"};